<template>
    <header id="header" :class="[$route.name]">
        <nav class="navigation" :class="{ 'is-home': isMobHome }">
            <div class="mobile-logo">
                <router-link
                    :to="{ name: 'home' }"
                    class="iconfont icon-logo logo"
                ></router-link>

                <i
                    v-if="!isMobHome"
                    @click="mobileSearch"
                    ref="mobileSearchIcon"
                    class="iconfont icon-search mobile-search"
                />
            </div>
            <div class="nav-box">
                <ul
                    v-if="!isMobDetail"
                    class="nav-list text-secondary"
                    :class="{ 'is-home': isMobHome }"
                >
                    <li v-for="(navItem, index) in dynamicNav" :key="index">
                        <router-link
                            :class="{ current: currentRouth == navItem.name }"
                            :to="
                                navItem.name === 'women'
                                    ? { name: navItem.name, query: { sex: 2 } }
                                    : { name: navItem.name }
                            "
                        >
                            {{ navItem.title }}
                        </router-link>
                    </li>
                </ul>

                <!-- search list -->
                <div
                    class="nav-search"
                    v-if="!isMob || (mobileShowSearch && !isMobHome)"
                >
                    <input
                        type="text"
                        v-model="searchKey"
                        placeholder="SEARCH"
                        @keyup.enter="searchEnterFun"
                        ref="input"
                    />
                    <i
                        ref="pcSearchIcon"
                        @click.stop="onSearch"
                        class="iconfont icon-search cursor-pointer"
                    />
                    <transition name="slide-fade">
                        <div
                            class="show-custom"
                            v-show="isSearch"
                            v-loading="searchLoading"
                            ref="search"
                        >
                            <div class="list-wrapper" v-if="model.length">
                                <div class="search-title">
                                    Models About“<span class="text-main">{{
                                        searchKey
                                    }}</span
                                    >”
                                </div>

                                <div class="result-list">
                                    <template v-for="(v, i) in model">
                                        <div
                                            v-if="i < 4"
                                            :key="i"
                                            class="custom-item"
                                            :style="{
                                                backgroundImage: `url(${v.link})`,
                                            }"
                                            @click="onJump(v, 'detail')"
                                        >
                                            <div class="name">
                                                <div>{{ v.last_name }}</div>
                                                <div>{{ v.first_name }}</div>
                                            </div>
                                            <div class="mask" />
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <div class="list-wrapper news" v-if="news.length">
                                <div class="search-title">
                                    <span>
                                        News About“<span class="text-main">{{
                                            searchKey
                                        }}</span
                                        >”
                                    </span>
                                    <span
                                        class="more text-main cursor-pointer"
                                        v-show="news.length > 4"
                                        @click="onClickMoreNews()"
                                    >
                                        MORE
                                    </span>
                                </div>

                                <div class="result-list">
                                    <template v-for="(v, i) in news">
                                        <div
                                            v-if="i < 4"
                                            :key="i"
                                            class="custom-item"
                                            :style="{
                                                backgroundImage: `url(${v.link})`,
                                            }"
                                            @click="onJump(v, 'news')"
                                        >
                                            <div class="mask" />
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <placeholder-box
                                v-if="
                                    !model.length &&
                                        !news.length &&
                                        !searchLoading
                                "
                            />
                        </div>
                    </transition>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
export default {
    name: 'website-header',

    data() {
        return {
            dynamicNav: [
                {
                    title: 'WOMEN',
                    name: 'women',
                },
                {
                    title: 'MEN',
                    name: 'men',
                },
                {
                    title: 'NEWS',
                    name: 'news',
                },
                {
                    title: 'CONTACT',
                    name: 'contact',
                },
            ],
            searchKey: '',
            isSearch: false,
            searchLoading: false,
            model: [],
            news: [],
            mobileShowSearch: true,
        };
    },

    computed: {
        isMob() {
            return this.$store.state.cw < 768;
        },
        currentRouth() {
            return this.$route.name;
        },

        isMobHome() {
            return this.currentRouth === 'home' && this.isMob;
        },

        isMobDetail() {
            return this.currentRouth === 'detail' && this.isMob;
        },
    },

    created() {},

    mounted() {
        this.mobileShowSearch = this.$store.state.cw > 768;

        document.addEventListener('click', (e) => {
            const wrapper = this.$refs.search;
            const input = this.$refs.input;
            const mobileSearchIcon = this.$refs.mobileSearchIcon;
            const pcSearchIcon = this.$refs.pcSearchIcon;

            if (this.$store.state.cw >= 768) {
                if (!wrapper || !input) return;
                if (
                    (wrapper && !wrapper.contains(e.target)) ||
                    (input && !input.contains(e.target)) ||
                    (pcSearchIcon && !pcSearchIcon.contains(e.target))
                ) {
                    this.searchLoading = false;
                    this.searchKey = '';
                }
            } else if (
                mobileSearchIcon && !mobileSearchIcon.contains(e.target) &&
                input && !input.contains(e.target)
            ) {
                this.searchLoading = false;
                this.searchKey = '';
                this.mobileShowSearch = false;
            }
        });
        // }
    },

    watch: {
        searchKey(value) {
            if (!value) {
                this.isSearch = false;

                setTimeout(() => {
                    this.model = [];
                    this.news = [];
                }, 500);
            }
        },
    },

    methods: {
        searchEnterFun(e) {
            const keyCode = window.event ? e.keyCode : e.which;

            if (keyCode === 13 && this.searchKey) {
                this.onSearch();
            }
        },

        onSearch() {
            if (!this.searchKey) return;

            this.isSearch = true;
            this.searchLoading = true;

            this.$http
                .getSearchList({
                    search: this.searchKey,
                })
                .then((res) => {
                    this.model = res.model;
                    this.news = res.new;
                })
                .finally(() => {
                    this.searchLoading = false;
                });
        },

        onJump({ id = '' }, type = 'detail') {
            if (!id) return;

            if (this.$store.state.cw < 768) {
                this.mobileShowSearch = false;
            }
            const router = { name: type, params: { id } };
            this.$router.push(router);

            this.searchKey = '';
        },

        onClickMoreNews() {
            // this.mobileShowSearch = false;
            if (this.$store.state.cw < 768) {
                this.mobileShowSearch = false;
            }
            this.$router.push({
                name: 'news',
                query: { searchKey: this.searchKey },
            });
        },

        mobileSearch() {
            this.mobileShowSearch = !this.mobileShowSearch;

            this.searchKey = '';
        },
    },
};
</script>

<style lang="scss">
#header {
    box-sizing: border-box;
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    right: 0;
    background: transparent;
    transform: translate3d(0, 0, 0);
    transition: 0.6s;
    background: #fff;

    height: 130px;
    @include media-mob {
        height: 120px;

        &.detail {
            height: 74px;
        }
    }
    // transform: translate3d(0, 0, 0);
    // transition: 0.6s;

    .hover-color {
        &:hover {
            color: #f43545;
        }
    }

    @include media {
        width: 100vw;
    }

    .navigation {
        height: 130px;
        margin: auto;
        box-sizing: content-box;
        width: 1600px;
        box-sizing: border-box;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include media-mob {
            width: calc(100vw - 40px);
            margin: auto;
            flex-direction: column;
            height: auto;
            align-items: flex-start;
            padding-top: 25px;

            &.is-home {
                padding-top: 0;

                .logo {
                    margin: 100px auto 76px;
                }

                li > a {
                    font-size: 16px;
                }
            }
        }

        .mobile-logo {
            @include media-mob {
                display: flex;
                justify-content: flex-start;
                width: 100%;
                position: relative;
            }
            .mobile-search {
                display: none;
                @include media-mob {
                    display: block;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 0;
                    font-size: 20px;
                }
            }
        }

        .logo {
            font-size: 39px;
            display: block;
            transition: all 0.6s;
            @include media-mob {
                font-size: 24px;
            }
        }

        .nav-box {
            display: flex;
            align-items: center;
            @include media-mob {
                flex-direction: column;
                width: 100%;
            }
        }

        .nav-list {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            @include media-mob {
                width: 100%;
                justify-content: space-between;

                &.is-home {
                    flex-direction: column;
                }
            }
        }

        li {
            display: inline-block;

            & > a {
                position: relative;
                display: block;
                font-family: Didot-Bold, Didot;
                padding: 10px 0 14px;
                margin: 0 30px;
                font-size: 20px;
                font-weight: bold;
                color: #333;
                line-height: 1;
                @include media-mob {
                    font-size: 14px;
                    padding: 30px 0 25px;
                    margin: 0;
                }

                &:after {
                    content: "";
                    position: absolute;
                    display: block;
                    width: 100%;
                    height: 1px;
                    background: #ba9153;
                    bottom: 0;
                    left: 50%;
                    transition: 0.3s ease;
                    transform: translateX(-50%) scaleX(0);
                }

                &.current {
                    color: #ba9153;
                    &:after {
                        @include media-mob {
                            display: none;
                        }
                        transform: translateX(-50%) scaleX(1);
                    }
                }
            }
        }

        .nav-search {
            font-family: Didot-Bold, Didot;
            position: relative;
            margin-left: 30px;
            @include media-mob {
                width: 100%;
                // border: 1px solid #555;
                padding: 30px;
                box-sizing: border-box;
                margin: 0;
                &:after {
                    display: block;
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    border: 1px solid #555;
                    z-index: 0;
                }
            }
            input {
                width: 165px;
                height: 24px;
                background: #fff;
                border: 1.5px solid #333;
                padding: 0 24px 0 10px;
                box-sizing: border-box;

                font-size: 14px;
                font-family: Didot-Bold, Didot;
                color: #333333;
                line-height: 1;
                @include media-mob {
                    width: 100%;
                    height: 28px;
                    position: relative;
                    z-index: 2;
                }
                &::placeholder {
                    color: #333333;
                }
            }

            .icon-search {
                position: absolute;
                top: 50%;
                right: 10px;
                font-size: 15px;
                transform: translateY(-50%);
                z-index: 10;
                @include media-mob {
                    right: 40px;
                    z-index: 2;
                }
            }

            .show-custom {
                position: absolute;
                top: 100%;
                right: 0;
                font-size: 0;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;

                width: 456px;
                min-width: 128px;
                height: auto;
                min-height: 128px;
                padding: 20px;
                background: #fff3e8;
                // transition: all 0.3s ease;
                @include media-mob {
                    width: 100%;
                    left: 0;
                    padding: 20px 30px;
                }
                .list-wrapper {
                    width: 100%;

                    &:nth-of-type(2) {
                        margin-top: 22px;
                    }

                    &.news {
                        padding-right: 6px;

                        .search-title {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                        }
                    }
                }

                .search-title {
                    font-size: 16px;
                    line-height: 1;
                    padding-bottom: 8px;
                    text-align: left;

                    .text-main {
                        color: #ba9153;
                    }
                    .more {
                        font-size: 12px;
                        cursor: pointer;
                        &:hover {
                            font-weight: bold;
                        }
                    }
                }
            }

            .result-list {
                width: 100%;
                display: flex;
                @include media-mob {
                    flex-wrap: wrap;
                }
            }

            .custom-item {
                width: 88px;
                height: 88px;
                box-sizing: border-box;
                background: rgba(0, 0, 0, 0.4) center/cover no-repeat;
                border: 2px solid #fff3e8;
                margin-right: 20px;
                position: relative;
                cursor: pointer;
                transition: all 0.3s ease;
                flex-shrink: 0;
                // filter: grayscale(100%);
                // opacity: 0.66;

                @include media-mob {
                    width: 123px;
                    height: 123px;
                    margin-right: 20px;
                    &:nth-child(2n) {
                        margin-right: 0;
                    }
                    &:nth-child(3),
                    &:nth-child(4) {
                        margin-top: 30px;
                    }
                }

                &:hover {
                    border: 2px solid #ba9153;

                    // filter: none;
                    // opacity: 1;
                    // background: rgba(0, 0, 0, 0);
                    .mask {
                        background: transparent;
                    }
                }

                &:nth-child(4n) {
                    margin-right: 0;
                }

                .mask {
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    right: 0;
                    // width: 88px;
                    // height: 88px;
                    background: rgba(0, 0, 0, 0.4);
                    z-index: 1;
                    transition: all 0.3s ease;
                }

                .name {
                    z-index: 10;
                    display: inline-block;
                    position: absolute;
                    left: 0;
                    bottom: 8px;
                    width: 100%;

                    font-size: 12px;
                    // font-family: Helvetica;
                    color: #ffffff;
                    line-height: 14px;
                }
            }
        }
    }
}
</style>
